/**
 * Employee code format (legacy parity):
 *   UTZ + DDMMYY + / + phone digits
 *   e.g. UTZ010726/9875623689
 *
 * DDMMYY comes from date of joining when set; otherwise the creation date.
 */

const EMPLOYEE_CODE_PREFIX = 'UTZ';

export function formatEmployeeCodeDatePart(date: Date): string {
  const dd = String(date.getUTCDate()).padStart(2, '0');
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const yy = String(date.getUTCFullYear()).slice(-2);
  return `${dd}${mm}${yy}`;
}

export function normalizeEmployeeCodePhoneDigits(phone: string | null | undefined): string {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
}

export function parseEmployeeCodeAnchorDate(
  dateOfJoining: string | null | undefined,
  asOf: Date,
): Date {
  if (dateOfJoining) {
    const m = dateOfJoining.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const year = Number(m[1]);
      const month = Number(m[2]);
      const day = Number(m[3]);
      const parsed = new Date(Date.UTC(year, month - 1, day));
      if (!Number.isNaN(parsed.getTime())) return parsed;
    }
  }
  return new Date(Date.UTC(asOf.getUTCFullYear(), asOf.getUTCMonth(), asOf.getUTCDate()));
}

export function buildEmployeeCode(input: {
  dateOfJoining?: string | null;
  phone?: string | null;
  asOf?: Date;
}): string | null {
  const phoneDigits = normalizeEmployeeCodePhoneDigits(input.phone);
  if (phoneDigits.length < 7) return null;

  const anchor = parseEmployeeCodeAnchorDate(input.dateOfJoining ?? null, input.asOf ?? new Date());
  return `${EMPLOYEE_CODE_PREFIX}${formatEmployeeCodeDatePart(anchor)}/${phoneDigits}`;
}

/** Append `-2`, `-3`, … before uniqueness is exhausted. */
export function employeeCodeCollisionVariant(base: string, attempt: number): string {
  if (attempt <= 1) return base;
  return `${base}-${attempt}`;
}
